import { BrainstormNodeData, TypeBrainstormNode } from "./brainstorm-node/brainstorm-node.model";
import { ChatNodeData, TypeChatNode } from "./response-node/response-node.model";
import { MemoNodeData, TypeMemoNode } from "./memo-node/memo-node.model";
import { TopicNodeData, TypeTopicNode } from "./topic-node/topic-node.model";

export type CreativeNodeData = 
  BrainstormNodeData |
  ChatNodeData |
  TopicNodeData |
  MemoNodeData;

export type CreativeNode = 
  TypeBrainstormNode |
  TypeChatNode |
  TypeTopicNode |
  TypeMemoNode;

// State of Semantic Zoom Content
// Show ZoomState.value if zoom <= value
export enum ZoomState {
  // MAX ZOOM = 3
  PREDIVEIN = 2.5,    // Indicates Semantic Dive In ready
  ALL = 0.75,         // ALL if zoom <= 0.75
  LINES = 0.6,        // Summarizes individual lines
  SUMMARY = 0.5,
  KEYWORDS = 0.4,
  PREDIVEOUT = 0.4,  // indicates Semantic Dive Out ready
  NONE = 0,
  // MIN ZOOM = 0.3
}

// enum for a 3 state input/click ui system
export enum InputHoverState {
  OUT = 'out',
  HOVER = 'hover',
  CLICKED = 'clicked',
}